import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import PopupManager from '../utils/PopupManager';
import NewsletterLogic from '../logics/NewsletterLogic';
import { IS_PRIVACY_PAGE } from '../utils/Environment';

export default class NewsletterPopupComponent extends Component {
    get SELECTORS() {
        return {
            closeBtn: '.news-p__close',
            newsletterBox: '.w-newsletter-popup',
            newsletterWrapper: '.register',
            newslettersuccess: '.news-p__success',
            form: '.js-newsletter-popup-form',
            jsContent: '.js-modal-popup-form-contents',
            input: '.data-newsletter-p-input',
            submitButton: '.nl-popup-submission',
            checkSubmitBtns: '.check-submit-popup',
            privacyCheckbox: '#privacy-news-popup',
            formWrapper: '.news-p__form__input',
            errorSubscribed: '.error-popup-already-subscribed',
            errorEmail: '.error-popup-email-invalid',
            errorGeneric: '.error-popup-generic'
        };
    }

    get CLASSES() {
        return {
            success: 'success',
            componentExtended: 'extended',
            disabled: 'disabled',
        };
    }

    constructor(htmlEl) {
        super(htmlEl);
        this.input = this.$component.querySelector(this.SELECTORS.input);
        this.label = this.$component.querySelector(this.SELECTORS.label);
        this.form = this.$component.querySelector(this.SELECTORS.form);
        this.checkSubmitBtns = this.$component.querySelectorAll(this.SELECTORS.checkSubmitBtns);
        this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
        this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
        this.newsletterBox = this.$component.querySelector(this.SELECTORS.newsletterBox);
        this.formWrapper = this.$component.querySelector(this.SELECTORS.formWrapper);
        this.errorSubscribed = this.$component.querySelector(this.SELECTORS.errorSubscribed);
        // this.errorPrivacy = this.$component.querySelector(this.SELECTORS.errorPrivacy);
        this.errorEmail = this.$component.querySelector(this.SELECTORS.errorEmail);
        this.errorGeneric = this.$component.querySelector(this.SELECTORS.errorGeneric);
        this.newsletterWrapper = this.$component.querySelector(this.SELECTORS.newsletterWrapper);
        this.newslettersuccess = this.$component.querySelector(this.SELECTORS.newslettersuccess);
    }

    initProperties() {
        this.modalkey = $(document.body).data('nlKey') ? $(document.body).data('nlKey') : 'default_modal';
        this.hideCookieKey = 'nl_' + this.modalkey + '_hide';
        this.link = $(document.body).data('nlLink') ? $(document.body).data('nlLink') : '/modals/newsletter';
    }

    listenPrivacyCheckBox() {
        if (this.privacyCheckbox.checked) {
            if (this.input.value != '') {
                this.submitButton.disabled = false;
                this.submitButton.classList.remove(this.CLASSES.disabled);
            } else {
                this.submitButton.disabled = true;
                this.submitButton.classList.add(this.CLASSES.disabled);
            }
        } else {
            this.submitButton.disabled = true;
            this.submitButton.classList.add(this.CLASSES.disabled);
        }
    }

    listenEmailInput(event) {
        if (event.target.value != '') {
            if (this.privacyCheckbox.checked) {
                this.submitButton.disabled = false;
                this.submitButton.classList.remove(this.CLASSES.disabled);
            } else {
                this.submitButton.disabled = true;
                this.submitButton.classList.add(this.CLASSES.disabled);
            }
        } else {
            this.submitButton.disabled = true;
            this.submitButton.classList.add(this.CLASSES.disabled);
        }
    }

    openNewsletterPopup() {

        let ctx = this;

        if (!Cookies.get(this.hideCookieKey) && !IS_PRIVACY_PAGE ) {
            // EMIT this event when needed to show newsletter popup after 6 sec
            setTimeout(function () {
                ctx.$emit(ctx.$customEvents.NL_POPUP_EVENTS.show, { component: ctx });
            }, 6000);
        }
    }

    bindEvents() {
        let ctx = this;
        
        this.$on(this.$customEvents.NL_POPUP_EVENTS.show, ({ event, payload }) => {
            this.input && this.input.addEventListener('input', (e) => this.listenEmailInput(e));
            this.privacyCheckbox && this.privacyCheckbox.addEventListener('change', () => this.listenPrivacyCheckBox());
            // bind submit
            this.$on('submit.nl-popup-submission', this.NewsletterLogic.subscribeToNewsletter, ctx.SELECTORS.newsletterBox, ctx.SELECTORS.form, ctx);
        });
        // after subscription event
        this.$on(this.$customEvents.NL_POPUP_EVENTS.subscribed, ({ event, payload }) => {
            // go logic
            this.NewsletterLogic.afterSubscription(ctx);
            // set cookie
            Cookies.set(this.hideCookieKey, 'true', {
                expires: 365,
                path: '/'
            });
        });
        // after open event
        this.$on(this.$customEvents.NL_POPUP_EVENTS.shown, ({ event, payload }) => {
            //
            let closeBtn = ctx.$component.querySelector(ctx.SELECTORS.closeBtn);
            if (closeBtn != null) {
                closeBtn.addEventListener('click', () => {
                    Cookies.set(this.hideCookieKey, 'true', {
                        path: '/'
                    });
                });
            }
        });
    }

    render() {
        let ctx = this;
        // loading logics
        this.NewsletterLogic = new NewsletterLogic();
        // properties
        this.initProperties();
        // popup manager
        this.popupManager = new PopupManager({
            eventGroup: 'NL_POPUP_EVENTS',
            component: this.$component,
        });
        // events
        this.bindEvents();
        // check the cookies


        if ($('.w-communication-popup').length <= 0 && !Cookies.get(this.hideCookieKey) && !IS_PRIVACY_PAGE) {
            // EMIT this event when needed to show newsletter popup after 5 sec
            console.log('dentro');
            setTimeout(function () {
                ctx.$emit(ctx.$customEvents.NL_POPUP_EVENTS.show, { component: ctx });
            }, 6000);
        }
    }
}
